import React, { Fragment, ReactElement } from 'react';

export const Copyright = (): ReactElement => {
	return (
		<Fragment>
			&copy; 2008–{new Date().getFullYear()} BambooHR {window.jQuery ? $.__('All rights reserved') : 'All rights reserved'}.
		</Fragment>
	);
};
